import React from 'react';
import { ChatbotProvider, useChatbot } from './ChatbotContext';
import ChatInterface from './ChatInterface';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';

// This component is used inside the ChatbotProvider
const ChatbotButton: React.FC = () => {
  const { isOpen, toggleChatbot } = useChatbot();
  const { t } = useTranslation();

  if (isOpen) {
    return null;
  }

  return (
    <button
      onClick={toggleChatbot}
      className="fixed bottom-4 right-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-white shadow-lg hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 z-50"
      aria-label={t('chatbot.openChat', 'Open chat')}
    >
      <ChatBubbleLeftRightIcon className="h-6 w-6" />
    </button>
  );
};

// This component wraps everything with the ChatbotProvider
export const ChatbotContainer: React.FC = () => {
  return (
    <ChatbotProvider>
      <ChatbotContainerInner />
    </ChatbotProvider>
  );
};

// This inner component uses the context provided by ChatbotProvider
const ChatbotContainerInner: React.FC = () => {
  const { isOpen } = useChatbot();

  return (
    <>
      <ChatbotButton />
      {isOpen && <ChatInterface />}
    </>
  );
};

export default ChatbotContainer;
